<template>
  <b-card-code title="Tambah Satuan Kerja">
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Periode Anggaran"
                rules="required|length:4|integer"
              >
                <label for="">Periode Anggaran</label>
                <b-form-input
                  v-model.number="model.periodeAnggaran"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Masukan Tahun Anggaran "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Anggaran Belanja"
                rules="required|integer"
              >
                <label for="">Anggaran Belanja</label>
                <b-form-input
                  v-model.number="model.anggaranBelanja"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Masukan Anggaran Belanja"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Anggaran Belanja PDN"
                rules="required|integer"
              >
                <label for="">Anggaran Belanja PDN</label>
                <b-form-input
                  v-model.number="model.anggaranBelanjaPDN"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Masukan Anggaran Belanja PDN"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Target Nilai TKDN"
                rules="required"
              >
                <label for="">Target Nilai TKDN</label>
                <b-form-input
                  v-model="model.targetNilaiTKDN"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Target Nilai TKDN"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <label for="">Target Vendor</label>
            <b-form-select
              :options="filterVendor"
              v-model="model.targetVendor"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="d-flex align-items-center justify-content-end mt-1">
              <b-button
                variant="outline-secondary"
                class="mr-1"
                :to="{ name: 'satuan-kerja' }"
              >
                <span class="text-nowrap">Batal</span>
              </b-button>
              <b-button
                variant="primary"
                type="submit"
                @click.prevent="validationForm"
              >
                <span class="text-nowrap">Tambah</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, integer, length } from '@validations';
import vSelect from 'vue-select';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BCardCode,
  },

  data() {
    return {
      file1: null,
      model: {
        targetVendor: 1,
      },
      selected: null,
      provinsi: null,
      required,
      integer,
      length,
      filterVendor: [
        { value: 1, text: 'UMKM' },
        { value: 2, text: 'NON UMKM' },
      ],
    };
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line
          this.confirmText();
        }
      });
    },
    async create() {
      const data = {
        Periode_Anggaran: this.model.periodeAnggaran,
        Anggaran_Belanja: this.model.anggaranBelanja,
        Anggaran_Belanja_PDN: this.model.anggaranBelanjaPDN,
        Target_Nilai_TKDN: this.model.targetNilaiTKDN,
        Target_Vendor: this.model.targetVendor,
      };

      const response = await this.$store.dispatch(
        'rencanabelanja/createRencanaBelanja',
        data
      );

      if (response.status == 200) {
        this.$swal
          .fire('Data Berhasil di Disimpan!', '', 'success')
          .then(() => {
            this.$router.push('/rencana-belanja');
          });
      }
    },
    confirmText() {
      this.$swal({
        title: 'Simpan Data?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, simpan data!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.create();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
